import getUrlParameter from "../utils/get-url-parameter"
import logger from "../utils/logger"

window._eightselect_shop_plugin = window._eightselect_shop_plugin || {}
window._eightselect_config = window._eightselect_config || {}
window._eightselect_config.widgets = window._eightselect_config.widgets || {}
window._eightselect_config.featureFlags = { observeDOM: true }

function createBadges() {
  return {
    sale: (product) => {
      try {
        const discountBadge = product.badges.find((badge) =>
          badge.startsWith("sale_discount_")
        )

        const discount = discountBadge.split("_")[2]

        if (!discount || discount === "0") {
          return ""
        }

        return `Save -${discount}%`
      } catch (error) {
        return ""
      }
    },
    new: isEnShop() ? "New" : "Neuware",
    new_in: "New in"
  }
}

function createWidgetConfig() {
  const widgetUrl = `https://wgt.8select.io/8.widget-app/index.html`

  const rightArrowMarkup = `<svg xmlns='http://www.w3.org/2000/svg' width='16' height='17' fill='none'><path fill='#202020' d='m13.854 7.682-4.5-4.5a.5.5 0 1 0-.708.707l3.647 3.646H2.5a.5.5 0 1 0 0 1h9.793l-3.647 3.647a.5.5 0 0 0 .708.707l4.5-4.5a.5.5 0 0 0 0-.707'/></svg>`

  const customWidgetStyles = `.widget__header__title { font-family: "STIX Two Text", serif; font-weight: 400; font-size: 2rem; line-height: 2.5rem; color: #202020; }`

  const commonSetup = {
    widgetUrl,
    customWidgetStyles,
    customizationOptions: {
      widget: {
        type: "setCompose",
        title: "",
        cssFilePath: "buddyandselly-com/styles/production.css",
        customBreakPoints: {
          xs: "440px",
          sm: "599px",
          md: "899px",
          lg: "1499px",
          xl: "1600px"
        }
      },
      layout: {
        type: "slidy"
      },
      productCard: {
        image: {
          useOriginalImage: true
          // formatOriginalUrl can not be cloned, so specifiy per widget
        },
        price: {
          currency: {
            order: 1
          }
        },
        remove: {
          addToCart: true,
          alternativeBadge: true,
          variants: true
        }
      },
      slider: {
        settings: { lazyLoad: "progressive", speed: 300 },
        normalizeArrowStyles: true,
        rightArrowMarkup,
        responsiveSettings: {
          xl: {
            slidesToShow: 3.95,
            slidesToScroll: 4
          },
          lg: {
            slidesToShow: 3.97,
            slidesToScroll: 4
          },
          md: {
            slidesToShow: 3,
            slidesToScroll: 3
          },
          sm: {
            slidesToShow: 2,
            slidesToScroll: 2
          },
          xs: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      },
      featureFlags: {
        hideNonTriggerAlternativeBadge: true,
        moveTriggerProductSlotToEnd: "always",
        skipTriggerProductInSlider: true,
        withAlternativesBox: false,
        withAlternativesInSlider: true,
        withProductDetailsView: false
      }
    }
  }

  return JSON.parse(JSON.stringify(commonSetup))
}

function isEnShop() {
  return window.location.pathname.indexOf("/de-en/") === 0
}

function setupWidget() {
  window._eightselect_config.widgets.Set = createWidgetConfig()
  window._eightselect_config.widgets.Set.customizationOptions.productCard.badges =
    createBadges()

  window._eightselect_config.widgets["Set_cart-layer"] = createWidgetConfig()
  window._eightselect_config.widgets[
    "Set_cart-layer"
  ].customizationOptions.productCard.badges = createBadges()
  window._eightselect_config.widgets[
    "Set_cart-layer"
  ].customizationOptions.widget.title = isEnShop()
    ? "Matching items"
    : "Passende Artikel"
  window._eightselect_config.widgets[
    "Set_cart-layer"
  ].customWidgetStyles += `#es-widget-app { margin-top: 20px;}`
}

function setupFullsizeWidget() {
  try {
    const css = document.createElement("style")
    css.type = "text/css"
    const styles = `
      [data-8select-widget-id][data-touchpoint="product"] {
        position: relative;
        width: 100vw;
        left: -0.75rem;
        margin-top: -4rem;
      }
      @media (min-width: 600px) {
        [data-8select-widget-id][data-touchpoint="product"] {
          left: -1.25rem;
        }
      }
      @media (min-width: 900px) {
        [data-8select-widget-id][data-touchpoint="product"] {
          left: calc((100vw - 100%) / -2);
        }
      }
    `

    if (css.styleSheet) {
      css.styleSheet.cssText = styles
    } else {
      css.appendChild(document.createTextNode(styles))
    }
    document.getElementsByTagName("head")[0].appendChild(css)
  } catch (_ignore) {}
}

function setupCartLayer() {
  try {
    const css = document.createElement("style")
    css.type = "text/css"

    const styles = `
			#cart-widget-8select {
				max-width: 1100px;
				width: calc(100% - (30rem + 20px));
				position: absolute;
				z-index:1;
				right: calc(30rem + 20px);
				top: 190px;
				display: none;
        }
      [data-8select-widget-id="8.SET"][data-touchpoint="cart-layer"]  {
        border-radius: 8px;
				margin-left: 20px;
				padding: 20px 20px 20px 0px;
        position: relative;
        background-color:#fcf8f7;
			}
			@media (min-width: 850px) {
        [data-8select-widget-id="8.SET"][data-touchpoint="cart-layer"]::after {
          content: '';
          width: 0;
          height: 0;
          border-top: 20px solid transparent;
          border-bottom: 20px solid transparent;
          border-left: 20px solid #fff;
          position: absolute;
          top: 65px;
          right: -19px;
        }
			}
			@media (min-width: 980px) {
      	#cart-widget-8select {
        	display: block;
        }
      }
		`

    if (css.styleSheet) {
      css.styleSheet.cssText = styles
    } else {
      css.appendChild(document.createTextNode(styles))
    }
    document.getElementsByTagName("head")[0].appendChild(css)
  } catch (error) {
    logger("Error during setupCartLayer()", error)
  }
}

function getProductPageProductId() {
  const productIdElement = document.querySelector(
    "#main-container > div > .main.container > .catalog-item[data-item-id]"
  )
  if (!productIdElement) {
    logger("Product ID element not found on product page")

    return null
  }

  return productIdElement.getAttribute("data-item-id")
}

function getCartLayerProductId() {
  const cartLayer = document.querySelector("#catalog-cart-layer")
  if (!cartLayer) {
    logger("Cart layer not found")

    return null
  }

  const img = cartLayer.querySelector('img[src*="/item/"]')
  if (!img) {
    logger("Product image not found in cart layer")

    return null
  }

  const match = img.src.match(/\/item\/([^/]+)/)

  if (!match) {
    logger("Product ID not found in cart layer image URL")

    return null
  }

  return match[1]
}

function createWidget(productId, touchpoint) {
  if (!productId) {
    logger(`No product ID provided for touchpoint: ${touchpoint}`)

    return null
  }

  const headline = isEnShop() ? "Matching items" : "Passende Artikel"
  const widget = `<div data-8select-widget-id="8.SET" data-touchpoint="${touchpoint}" data-identifier="${productId}"></div>`

  let previewInfo = ""

  if (touchpoint === "product") {
    return `<div class="flex-1 bg-beige-light mt-6 overflow-hidden -eightselect-widget-container"> <div class="main container"> <div class="item-recommendations py-12"> ${previewInfo} <h2 class="mb-6 pr-24">${headline}</h2> <div>${widget}</div> </div></div> </div>`
  }
  if (touchpoint === "cart-layer") {
    return `<div class="-eightselect-widget-container" id="cart-widget-8select">${widget}</div>`
  }

  return null
}

function observeElementState(selector, predicate, callback) {
  let timeoutId = null
  let observer

  const checkAndCallback = () => {
    const el = document.querySelector(selector)
    if (predicate(el)) {
      logger(`Element ${selector} is now in the desired state.`)

      if (observer) {
        observer.disconnect()
      }
      callback(el)
    }
  }

  observer = new MutationObserver(() => {
    if (timeoutId) {
      return
    }

    timeoutId = setTimeout(() => {
      timeoutId = null
      checkAndCallback()
    }, 100)
  })

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style", "class"]
  })

  checkAndCallback()
}

function isElementVisibleByStyle(el) {
  const style = window.getComputedStyle(el)
  return !(
    style.display === "none" ||
    style.visibility === "hidden" ||
    style.opacity === "0"
  )
}

function getElementRectSize(el) {
  const rect = el.getBoundingClientRect()
  return { width: rect.width, height: rect.height }
}

function onElementGone(selector, callback) {
  function isGone(el) {
    if (!el) return true
    if (!el.isConnected) return true
    if (!isElementVisibleByStyle(el)) return true
    const { width, height } = getElementRectSize(el)
    return width === 0 || height === 0
  }
  observeElementState(selector, isGone, () => callback())
}

function onElementVisible(selector, callback) {
  function isVisible(el) {
    if (!el) return false
    if (!el.isConnected) return false
    if (!isElementVisibleByStyle(el)) return false
    const { width, height } = getElementRectSize(el)
    return width > 0 && height > 0
  }
  observeElementState(selector, isVisible, callback)
}

function insertHtmlAtSelector(selector, html, position = "after") {
  if (!html || !selector) {
    logger("insertHtmlAtSelector: Invalid HTML or selector")
    return false
  }

  const el = document.querySelector(selector)
  if (!el) return false
  switch (position) {
    case "before":
      el.insertAdjacentHTML("beforebegin", html)
      break
    case "after":
      el.insertAdjacentHTML("afterend", html)
      break
    default:
      el.insertAdjacentHTML("afterend", html)
  }
  return true
}

function isWidgetInDom(touchpoint) {
  const widgetSelector = `[data-8select-widget-id="8.SET"][data-touchpoint="${touchpoint}"]`
  const widget = document.querySelector(widgetSelector)

  return widget !== null
}

function onElementVisibleRecurring(selector, callback) {
  function handleVisible(el) {
    callback(el)
    onElementGone(selector, () => {
      onElementVisible(selector, handleVisible)
    })
  }
  onElementVisible(selector, handleVisible)
}

function insertWidgets() {
  const productPageSelector =
    "#main-container > .flex-1.bg-beige-light.overflow-hidden"
  const cartLayerSelector = "#catalog-cart-layer"

  onElementVisible(productPageSelector, (el) => {
    if (isWidgetInDom("product")) {
      return
    }

    const widget = createWidget(getProductPageProductId(), "product")
    insertHtmlAtSelector(productPageSelector, widget, "after")
  })

  onElementVisibleRecurring(cartLayerSelector, (el) => {
    if (isWidgetInDom("cart-layer")) {
      return
    }

    const widget = createWidget(getCartLayerProductId(), "cart-layer")
    insertHtmlAtSelector(cartLayerSelector, widget, "before")
  })
}

function isPreview() {
  try {
    return localStorage.getItem("8S-preview") === "true"
  } catch (ignore) {
    return false
  }
}

function setupTestParameters() {
  try {
    if (getUrlParameter("8S-preview") === "true") {
      localStorage.setItem("8S-preview", "true")
    }
    if (getUrlParameter("8S-preview") === "false") {
      localStorage.removeItem("8S-preview")
    }
  } catch (error) {
    console.error("8SELECT: test parameter setup failed.", error)
  }
}
try {
  setupTestParameters()
  setupCartLayer()
  setupFullsizeWidget()
  setupWidget()

  insertWidgets()
  
} catch (error) {
  console.error("8SELECT: Error during setup", error)
}
